<template>
  <v-row>
    <v-col cols="12" md="12">
      <BaseBlock title="Page masquée (non présente dans le menu)">
        <h2 class="subtitle-1 font-weight-bold">
          Page n'apparaissant pas dans le menu principal
        </h2>
        <p>Cette page n'apparait pas dans le menu principal</p>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "MaskedPage",
  components: { BaseBlock },
};
</script>
